export default {
  appName: "Arise Youth Employment Portal",
  domain: process.env.NODE_ENV === 'production' ? "https://employment.akwaibomstate.gov.ng" : "http://127.0.0.1:8000",
  localUserKey: "tdfebmizxeemitbuqalxuoypu",
}
  